<template>
  <v-stepper-content step="2">
    <v-content fluid grid-list-lg style="padding: 0;">
      <v-layout row wrap>
        <v-flex md6>
          <v-subheader class="pl-0">Patient Date of Birth</v-subheader>
          <datepick
            dob
            label="DOB"
            min="1900-01-01"
            :max="new Date().toISOString().substr(0, 10)"
            :value="new Date(att.patientDOB || 0)"
            @input="att.patientDOB = $event"
            :disabled="lock"
            :error-messages="errs.patientDOB"
            @update:form="clearErr('patientDOB')"
          />
        </v-flex><v-flex md6>
          <v-subheader class="pl-0">Patient ID</v-subheader>
          <v-text-field
            label="ID"
            v-model="att.patient"
            :error-messages="errs.patient"
            :disabled="lock"
            @change="clearErr('patient')"
            :messages="
              att.patient && !patIDValid
                ? 'Warning: No matching ID found. This will be accepted'
                + ' but please make sure you have entered the ID correctly.'
                : ''
            "
          />
        </v-flex>
      </v-layout>
    </v-content>
    <v-btn @click="$emit('update:step', 1)" >Back</v-btn>
    <v-btn color="primary" @click="$emit('update:step', 3)" :disabled="!valid">Continue</v-btn>
    <v-btn
      v-if="id && !lock"
      color="secondary"
      @click="$emit('save')"
      :disabled="!valid || !changed"
      :loading="loading"
    >
      Save
    </v-btn>
  </v-stepper-content>
</template>

<script>
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import datepick from '../../datepick.vue';
import attemptEq from '../attemptEq';

export default {
  components: {
    datepick,
  },
  props: {
    attempt: {
      type: Object,
      default: () => ({ comments: {} }),
    },
    errs: {
      type: Object,
      default: () => ({ comments: {} }),
    },
    lock: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    changed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      att: { comments: {} },
      patIDValid: false,
    };
  },
  computed: {
    ...mapState('auth', ['user']),
    perm() { return this.user && this.user.perm; },
    id() { return this.att && this.att._id; },
    valid() { return this.att.patreq === false || (this.att.patient && this.att.patientDOB); },
  },
  methods: {
    setAtt() {
      if (!attemptEq(this.att, this.attempt)) this.att = cloneDeep(this.attempt);
    },
    clearErr(i) {
      const errs = cloneDeep(this.errors);
      set(errs, i, '');
      this.$emit('update:errors', errs);
    },
  },
  mounted() { this.setAtt(); },
  watch: {
    attempt: {
      handler() { this.setAtt(); },
      deep: true,
    },
    att: {
      handler() {
        if (!attemptEq(this.att, this.attempt)) this.$emit('update:attempt', this.att);
      },
      deep: true,
    },
    valid() { this.$emit('update:valid', this.valid); },
    async 'att.patient'() { // eslint-disable-line object-shorthand
      if (!this.att.patient) {
        this.patIDValid = false;
        return;
      }
      if (/(^~~~)|(^TE?M?P?0*$)/.test(this.att.patient)) {
        this.patIDValid = true;
        return;
      }
      const pats = await this.$store.dispatch('patients/find', {
        query: { patID: this.att.patient },
      });
      this.$store.commit('patients/clearAll');
      this.patIDValid = !!pats.length;
    },
  },
};
</script>
